import request from '@/utils/request';
// 获取点检列表
export const cycleCheckList = (params: any) =>
  request({
    url: 'CycleCheck/cycleCheckList',
    method: 'get',
    params
  });
  // 添加点检
export const addCycleCheck = (data: any) =>
  request({
    url: 'CycleCheck/CycleCheck',
    method: 'POST',
    data
  });
// 编辑点检
export const editCycleCheck = (data: any) =>
  request({
    url: 'CycleCheck/CycleCheck',
    method: 'PUT',
    data
  });
// 删除点检
export const delCycleCheck = (data: any) =>
  request({
    url: 'CycleCheck/CycleCheck',
    method: 'DELETE',
    data
  });
// 获取分公司
export const getBranchList = (params: any) =>
  request({
    url: 'Company/branchList',
    method: 'get',
    params
  });
  // 同步分公司
export const syncBranchCycleCheck = (data: any) =>
  request({
    url: 'CycleCheck/syncBranchCycleCheck',
    method: 'POST',
    data
  });
// 当日点检记录列表
export const getJobList = (params: any) =>
  request({
    url: 'CycleCheck/jobList',
    method: 'get',
    params
  });
// 历史点检记录列表
export const getRecordList = (params: any) =>
  request({
    url: 'CycleCheck/recordList',
    method: 'get',
    params
  });
// 点检时间二维码
export const getQrCode = (params: any) =>
  request({
    url: 'CycleCheck/qrCode',
    method: 'get',
    params
  });
  // 导出二维码
export const getBatchQrCode = (params: any) =>
  request({
    url: 'CycleCheck/batchQrCode',
    method: 'get',
    params,
    responseType: 'blob'
  });
  // 分公司点捡图标
export const getChartRecord = (params: any) =>
  request({
    url: 'CycleCheck/chartRecord',
    method: 'get',
    params
  });
  // 分公司点检记录
export const getBranchRecord = (params: any) =>
  request({
    url: 'CycleCheck/branchRecord',
    method: 'get',
    params
  });
  // 导出excel 统计
export const exportStatistics = (params: any) =>
  request({
    url: 'CycleCheck/exportStatistics',
    method: 'get',
    params
  });
// 导出excel 记录
export const exportRecord = (params: any) =>
  request({
    url: 'CycleCheck/exportRecordJob',
    method: 'get',
    params
  });
  //
export const branchStatistics = (params: any) =>
  request({
    url: 'CycleCheck/branchStatistics',
    method: 'get',
    params
  });
